import React from "react";
import AvatarEnum from "../../enums/avatar.enum";
import BrandEnum from "../../enums/brand.enum";
import IconEnum from "../../enums/icon.enum";
import assetImport from "../../helpers/assetImport";
import classMap from "../../helpers/classMap";
import convertToUpperSnakeCase from "../../helpers/convertToUpperSnakeCase";
import getIconEnumValue from "../../helpers/getIconEnumValue";
import isValidEnum from "../../helpers/isValidEnum";
import ImgIconProps from "./img-icon.props";

const ImgIcon = React.memo((props: ImgIconProps) => {
  const { theme } = props;
  // get size
  const getSize = (): string => getIconEnumValue(props.size);
  // extract enum key from pattern (ex: KEY: assets:icons/key.svg)
  const extractEnumKey = (icon: string) => {
    const match = icon.match(/:[a-z-0-9]+\/([a-z-0-9-_]+)/);
    return convertToUpperSnakeCase(match && match.length > 1 ? match[1] : icon);
  };
  const isValidIcon: boolean = isValidEnum(extractEnumKey(props.icon || ""), IconEnum, BrandEnum, AvatarEnum);
  return (
    <img
      alt={props.alt || props.title}
      src={isValidIcon ? assetImport(props.icon as string, theme) : props.icon}
      width={getSize()}
      height={props.squared ? getSize() : undefined}
      className={classMap("mpng-ux-icon mpng-ux-imgicon", props.className)}
      style={{ display: "inline-block" }}
    />
  );
});

export default ImgIcon;
